import { warnAndNotify } from '@execonline-inc/error-reporting.private';
import { URLParser, putQueryParam, toUrlT } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { callApi } from '../../../../../Appy';
import { currentUserStore } from '../../../../../CurrentUserStore';
import { findLinkT } from '../../../../../LinkyLinky';
import { SearchParameters } from '../../../../../ListFilter/Types';
import ReactionComponent, { RCProps } from '../../../../../ReactionComponent';
import { Link } from '../../../../../Resource/Types';
import { shareableLinksResourceDecoder } from './Decoders';
import ShareableLinksStore from './Store';
import { Loading, ShareableLinksError, ShareableLinksResource, State } from './Types';

interface Props extends RCProps<ShareableLinksStore> {
  store: ShareableLinksStore;
}

const withSearchParameters = (searchParameters: SearchParameters) => (url: URLParser) =>
  searchParameters.reduce(
    (acc, parameter) => putQueryParam(`deep_links_filter[${parameter.key}]`, parameter.value)(acc),
    url,
  );

const pageLink =
  (state: Loading) =>
  (link: Link): Task<ShareableLinksError, Link> =>
    toUrlT(link.href.replace('{learning_collection_id}', state.id))
      .map(withSearchParameters(state.searchParameters))
      .map((url): Link => ({ ...link, href: url.href }));

const load = (state: Loading): Task<ShareableLinksError, ShareableLinksResource> =>
  Task.succeed<ShareableLinksError, ReadonlyArray<Link>>(currentUserStore.links)
    .andThen(findLinkT('learning-collection-deep-links'))
    .andThen(pageLink(state))
    .andThen(callApi(shareableLinksResourceDecoder, {}));

const handleError = (store: ShareableLinksStore) => (error: ShareableLinksError) => {
  store.fail(error);
  warnAndNotify('ShareableLinksReactions', error.kind, error);
};

class ShareableLinksReactions extends ReactionComponent<ShareableLinksStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'loading':
        load(state).fork(handleError(store), store.ready);
        break;
      case 'ready':
      case 'failed':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ShareableLinksReactions;
